import React, { useState } from "react";
import { addClient } from "../../../services/Service";

const AddClient = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [clientSlug, setClientSlug] = useState("");
  const [userRole, setUserRole] = useState("");

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });

  const getErrorMessage = (error) => {
    const data = error?.response?.data;

    if (error?.message && !data) {
      return error.message;
    }

    if (typeof data?.message === "string" && data.message.trim()) {
      return data.message;
    }

    if (data?.errors && typeof data.errors === "object") {
      const firstFieldError = Object.values(data.errors).flat().find(Boolean);
      if (firstFieldError) return firstFieldError;
    }

    return "Failed to add client.";
  };

  const validateForm = () => {
    const newErrors = {};

    const nameRegex = /^[A-Za-z\u0900-\u097F\s]{3,}$/;
    if (!nameRegex.test(name.trim())) {
      newErrors.name =
        "Name must contain only letters (English or Marathi) and at least 3 characters.";
    }

    const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
    if (!clientSlug.trim()) {
      newErrors.clientSlug = "Client slug is required.";
    } else if (!slugRegex.test(clientSlug.trim())) {
      newErrors.clientSlug =
        "Slug must be lowercase, hyphen-separated (e.g. arnav-technosys-pune).";
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email.trim())) {
      newErrors.email = "Enter a valid email address.";
    }

    const phoneRegex = /^[6-9][0-9]{9}$/;
    if (!phoneRegex.test(phone.trim())) {
      newErrors.phone = "Phone number must start with 6-9 and be exactly 10 digits.";
    }

    if (!userRole) {
      newErrors.userRole = "Please select a user role.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    const clientData = {
      action_type: "I",
      client_name: name.trim(),
      client_slug: clientSlug.trim(),
      client_email: email.trim(),
      client_contact_number: phone.trim(),
      user_role_abbr: userRole,
      client_gstin: null,
      client_address: null,
      client_description: null,
      client_no_of_emp: null,
      client_profile_photo: null,
      p_page_size: null,
      p_page: null,
    };

    try {
      const response = await addClient(clientData);
      console.log("Client added:", response);

      setName("");
      setEmail("");
      setPhone("");
      setClientSlug("");
      setUserRole("");
      setErrors({});

      showToast("Client added successfully. Verification email sent.", "success");
      window.dispatchEvent(new Event("refreshClients"));
    } catch (error) {
      console.error("Failed to add client:", error);
      showToast(getErrorMessage(error), "danger");
    } finally {
      setLoading(false);
    }
  };

  const showToast = (message, type) => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 3000);
  };

  return (
    <div className="container-fluid px-0 px-md-2 py-0">
      <div className="row justify-content-center">
        <div className="col-xl-9 col-lg-10">
         
   <section
            className="rounded-4 p-4 p-lg-4 mb-1 text-white"
            style={{
              background:
                "linear-gradient(135deg, rgb(15, 23, 42) 0%, rgb(30, 41, 59) 48%, rgb(37, 99, 235) 100%)",
              boxShadow: "0 24px 60px rgba(15, 23, 42, 0.18)",
            }}
          >
            <div className="row align-items-center g-1">
              <div className="col-lg-12">
                {/* <div className="text-uppercase small fw-semibold opacity-75 mb-2">
                  Client Onboarding
                </div> */}
                <h4 className="mb-0" style={{ letterSpacing: "-0.03em" }}>
                  Add Client (Client Onboarding)
                </h4>
                {/* <p className="mb-0 fs-5 opacity-75">
                  Create a new client account, assign the admin type, and trigger the password setup flow.
                </p> */}
              </div>
              {/* <div className="col-lg-4">
                <div className="rounded-4 bg-white bg-opacity-10 p-4 border border-white border-opacity-25">
                  <div className="small text-uppercase opacity-75 mb-2">Setup Rules</div>
                  <div className="fw-semibold">Slug must be unique and lowercase.</div>
                  <div className="small opacity-75 mt-2">
                    Admin role can be Ticketbot or Leadbot from this screen.
                  </div>
                </div>
              </div> */}
            </div>
          </section>

          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body p-4 p-lg-5">
         
              <form onSubmit={handleSubmit}>
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Organization Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter organization name"
                      className={`form-control form-control-lg ${errors.name ? "is-invalid" : ""}`}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Client Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-select-lg ${errors.userRole ? "is-invalid" : ""}`}
                      value={userRole}
                      onChange={(e) => setUserRole(e.target.value)}
                    >
                      <option value="">Select role</option>
                      <option value="T">Ticketbot Admin</option>
                      <option value="L">Leadbot Admin</option>
                    </select>
                    {errors.userRole && (
                      <div className="invalid-feedback d-block">{errors.userRole}</div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Chatbot URL Slug <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. atai-leadbot-pune"
                      className={`form-control form-control-lg ${errors.clientSlug ? "is-invalid" : ""}`}
                      value={clientSlug}
                      onChange={(e) =>
                        setClientSlug(e.target.value.toLowerCase().replace(/\s+/g, "-"))
                      }
                    />
                    <div className="form-text">Chatbot URL will be: `/chatbot/{clientSlug || "your-slug"}`</div>
                    {errors.clientSlug && (
                      <div className="invalid-feedback d-block">{errors.clientSlug}</div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Email ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      placeholder="Enter valid email ID"
                      className={`form-control form-control-lg ${errors.email ? "is-invalid" : ""}`}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Phone Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter 10 digit number"
                      className={`form-control form-control-lg ${errors.phone ? "is-invalid" : ""}`}
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                    {errors.phone && <div className="invalid-feedback d-block">{errors.phone}</div>}
                  </div>
                </div>

                <div className="d-flex justify-content-end gap-3 mt-0 flex-wrap">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-lg px-4"
                    onClick={() => {
                      setName("");
                      setEmail("");
                      setPhone("");
                      setClientSlug("");
                      setUserRole("");
                      setErrors({});
                    }}
                    disabled={loading}
                  >
                    Reset
                  </button>
                  <button type="submit" className="btn btn-primary btn-lg px-5" disabled={loading}>
                    {loading ? "Adding..." : "Add Client"}
                  </button>
                </div>
              </form>
              
            </div>
          </div>

          {toast.show && (
            <div
              className="toast-container position-fixed top-0 end-0 p-3"
              style={{ zIndex: 1055 }}
            >
              <div className={`toast show text-white bg-${toast.type}`} role="alert">
                <div className="toast-body">{toast.message}</div>
              </div>
            </div>
          )}


        
        </div>
      </div>
    </div>
  );
};

export default AddClient;
